import { render, staticRenderFns } from "./pic_lollipop.vue?vue&type=template&id=b520ffc2&scoped=true"
import script from "./pic_lollipop.vue?vue&type=script&lang=js"
export * from "./pic_lollipop.vue?vue&type=script&lang=js"
import style0 from "./pic_lollipop.vue?vue&type=style&index=0&id=b520ffc2&prod&lang=css"
import style1 from "./pic_lollipop.vue?vue&type=style&index=1&id=b520ffc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b520ffc2",
  null
  
)

export default component.exports